import React from "react"
import { Table } from 'semantic-ui-react'
import ReactMarkdown from "react-markdown/with-html"

const TwoColTable = ({ header, rows }) => {
    return (
        <Table unstackable striped>
            {header && (
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>{header.Cell1}</Table.HeaderCell>
                        <Table.HeaderCell>{header.Cell2}</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
            )}

            <Table.Body>
                {rows.map((r, i) => {
                    return (
                        <Table.Row key={i}>
                            <Table.Cell><ReactMarkdown escapeHtml={false}>{r.Cell1}</ReactMarkdown></Table.Cell>
                            <Table.Cell><ReactMarkdown escapeHtml={false}>{r.Cell2}</ReactMarkdown></Table.Cell>
                        </Table.Row>
                    )
                })}
            </Table.Body>
        </Table>
    )
}

export default TwoColTable
